<template>
  <component
    @show-enlarged="showEnlarged"
    :is="`${node.data.object.type}-widget`"
    :widget="node.data"
  />
</template>

<script>
  import LayerWidget from '@/components/widgets/templates/templateWidgets/LayerWidget.vue';
  import TextWidget from '@/components/widgets/templates/templateWidgets/TextWidget.vue';
  import ClockWidget from '@/components/widgets/templates/templateWidgets/ClockWidget.vue';
  import ButtonWidget from '@/components/widgets/templates/templateWidgets/ButtonWidget.vue';
  import ImageWidget from '@/components/widgets/templates/templateWidgets/ImageWidget.vue';
  import AppWidget from '@/components/widgets/templates/templateWidgets/AppWidget.vue';
  import VideoWidget from '@/components/widgets/templates/templateWidgets/VideoWidget.vue';
  import PdfWidget from '@/components/widgets/templates/templateWidgets/PdfWidget.vue';
  import RichtextWidget from '@/components/widgets/templates/templateWidgets/RichTextWidget.vue';
  import AudioWidget from '@/components/widgets/templates/templateWidgets/AudioWidget.vue';
  import TenantWidget from '@/components/widgets/templates/templateWidgets/TenantsWidget.vue';
  import CommercialTenantWidget from '@/components/widgets/templates/templateWidgets/CommercialTenantsWidget.vue';
  import WeatherWidget from '@/components/widgets/templates/templateWidgets/WeatherWidget.vue';
  import TrafiklabWidget from '@/components/widgets/templates/templateWidgets/TrafiklabWidget.vue';
  import RssWidget from '@/components/playerWidgets/RssWidget.vue';
  import LinkWidget from '@/components/widgets/templates/templateWidgets/LinkWidget.vue';
  import VisualizeWidget from '@/components/widgets/templates/templateWidgets/VisualizeWidget.vue';
  import TableWidget from '@/components/widgets/templates/templateWidgets/TableWidget.vue';
  import TimeWidget from '@/components/widgets/templates/templateWidgets/TimeWidget.vue';
  import DateWidget from '@/components/widgets/templates/templateWidgets/DateWidget.vue';
  import MessageBoardWidget from '@/components/widgets/templates/templateWidgets/MessagesBoardWidget.vue';
  import CalendarWidget from '@/components/widgets/templates/templateWidgets/CalendarWidget.vue';

  export default {
    name: 'WidgetNode',
    props: {
      node: {
        type: Object,
        required: true,
        default: () => {},
      },
    },
    methods: {
      showEnlarged(w) {
        this.$emit('show-enlarged', w);
      },
    },
    components: {
      AudioWidget,
      ImageWidget,
      LayerWidget,
      TextWidget,
      ClockWidget,
      ButtonWidget,
      AppWidget,
      VideoWidget,
      PdfWidget,
      RichtextWidget,
      TenantWidget,
      CommercialTenantWidget,
      WeatherV2Widget: WeatherWidget,
      TrafiklabV2Widget: TrafiklabWidget,
      RssV2Widget: RssWidget,
      LinkWidget,
      VisualizeWidget,
      TableV2Widget: TableWidget,
      TimeWidget,
      DateWidget,
      MessageBoardWidget,
      CalendarWidget,
    },
  };
</script>

<style scoped></style>
